import React from "react";

export interface SectionRow {
  id: string;
  name: string;
  category?: string;
  date?: string;
  description?: string;
  onClick?: () => void;
  onAction?: () => void;
}

export interface Section {
  title: string;
  rows: SectionRow[];
  onViewMore?: () => void;
}

interface SectionedListProps {
  sections: Section[];
  maxRows?: number;
}

export const SectionedList: React.FC<SectionedListProps> = ({
  sections,
  maxRows = 5,
}) => {
  return (
    <>
      {sections
        .filter((s) => s.rows.length > 0)
        .map((section) => (
          <div key={section.title} className="vault-section">
            <div className="vault-section-header">
              <span className="vault-section-title">{section.title}</span>
              {section.onViewMore && (
                <button
                  className="vault-section-more"
                  onClick={section.onViewMore}
                >
                  View more
                </button>
              )}
            </div>
            <table className="vault-table">
              <tbody>
                {section.rows.slice(0, maxRows).map((row) => (
                  <tr
                    key={row.id}
                    className="vault-row"
                    onClick={row.onClick}
                  >
                    <td className="vault-row-icon">
                      <div className="vault-doc-icon" />
                    </td>
                    <td className="vault-row-name">{row.name}</td>
                    <td className="vault-row-category">
                      {row.category || ""}
                    </td>
                    <td className="vault-row-date">{row.date || ""}</td>
                    <td className="vault-row-desc">
                      {row.description || ""}
                    </td>
                    <td className="vault-row-actions">
                      <button
                        className="vault-more-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          row.onAction?.();
                        }}
                      >
                        &#8942;
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
    </>
  );
};
